// Daebak Theme - Global JavaScript

(function() {
  'use strict';

  // DOM Ready
  document.addEventListener('DOMContentLoaded', function() {
    initSmoothScroll();
    initLazyLoading();
    initAnimations();
  });

  // Smooth Scroll for anchor links
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
      anchor.addEventListener('click', function(e) {
        var href = this.getAttribute('href');
        if (href === '#') return;
        
        var target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }

  // Lazy Loading Images
  function initLazyLoading() {
    if ('loading' in HTMLImageElement.prototype) {
      // Browser supports lazy loading
      var images = document.querySelectorAll('img[loading="lazy"]');
      images.forEach(function(img) {
        if (img.dataset.src) {
          img.src = img.dataset.src;
        }
      });
    } else {
      // Fallback with Intersection Observer
      var lazyImages = document.querySelectorAll('img.lazy');
      
      if ('IntersectionObserver' in window) {
        var imageObserver = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              var image = entry.target;
              if (image.dataset.src) {
                image.src = image.dataset.src;
              }
              image.classList.remove('lazy');
              imageObserver.unobserve(image);
            }
          });
        });

        lazyImages.forEach(function(image) {
          imageObserver.observe(image);
        });
      }
    }
  }

  // Scroll Animations
  function initAnimations() {
    if (!('IntersectionObserver' in window)) return;

    var animatedElements = document.querySelectorAll('[data-animate]');
    
    var animationObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          animationObserver.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    animatedElements.forEach(function(el) {
      animationObserver.observe(el);
    });
  }

  // Debounce utility
  window.debounce = function(func, wait) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        func.apply(context, args);
      }, wait);
    };
  };

  // Throttle utility
  window.throttle = function(func, limit) {
    var inThrottle;
    return function() {
      var args = arguments;
      var context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(function() {
          inThrottle = false;
        }, limit);
      }
    };
  };

  // Format money
  window.formatMoney = function(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    
    function defaultOption(opt, def) {
      return typeof opt === 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents = parts[1] ? decimal + parts[1] : '';

      return dollars + cents;
    }

    switch (format || '${{amount}}') {
      case '{{amount}}':
        value = formatWithDelimiters(cents, 2);
        break;
      case '{{amount_no_decimals}}':
        value = formatWithDelimiters(cents, 0);
        break;
      case '{{amount_with_comma_separator}}':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case '{{amount_no_decimals_with_comma_separator}}':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return format.replace(placeholderRegex, value);
  };

})();
